import React from 'react';
import './TripOverview.css';

function TripOverview({ tour }) {
  return (
    <section className="trip-overview">
      <div className="trip-overview-container">
        <div className="trip-overview-content">
          <h2 className="trip-section-title">Overview</h2>
          <p className="trip-description">{tour.description}</p>
          
          {tour.highlights && tour.highlights.length > 0 && (
            <div className="trip-highlights">
              <h3 className="trip-highlights-title">Trip Highlights</h3>
              <ul className="trip-highlights-list">
                {tour.highlights.map((highlight, index) => (
                  <li key={index} className="trip-highlight-item">
                    <span className="trip-highlight-icon">✓</span>
                    {highlight}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default TripOverview;

